export default __webpack_public_path__ + "static/media/Widowdusk Bracers.3a79fb24.jpg";